import { render, staticRenderFns } from "./MarketTypeForm.vue?vue&type=template&id=803da0c6"
import script from "./MarketTypeForm.vue?vue&type=script&lang=js"
export * from "./MarketTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports